module.exports = __webpack_public_path__ + "static/media/ahmed.9cf6f7aa.webp";